import type { HeroDef } from "../../sim";
import { BASE_KIT_IDS } from "../abilities";
import { REACTION_BODY } from "./reactionBody";

/** Временный боец — манекен pixelfx (ADR 0002, способ В), пока нет моделей героев. Мерки — пиксели мира (картинка 640×360): манекен 38 px слоя ×4 = 152 px, 42 % высоты экрана. */
export const MANNEQUIN: HeroDef = {
  id: "mannequin",
  name: "Манекен",
  health: 1600,
  walkSpeed: 4,
  backSpeed: 3.2,
  jumpSpeed: 19,
  jumpForward: 6,
  gravity: 1,
  width: 76,
  hurtStand: { x: -27, y: -148, w: 54, h: 148 },
  hurtCrouch: { x: -28, y: -100, w: 56, h: 100 },
  hurtAir: { x: -24, y: -132, w: 48, h: 112 },
  // зона попадания в отдаче и в полёте идёт за корпусом клипа реакции (обмер — tools/capture/reaction.mjs)
  reactionBody: REACTION_BODY,
  kit: [
    ...BASE_KIT_IDS,
    "dash-strike",
    "flip-kick",
    "rising-strike",
    "magic-shot",
    "back-run",
    "taunt-come-on",
    "taunt-breakdance",
    "taunt-chicken",
    "shoulder-throw",
    "grab-whiff",
    "blink",
    "vanish",
  ],
  super: "squall",
};
